import type { SpeakerSide } from '../speaker';

/**
 * Заливка и текст строки реплики — цветами облака её стороны. Заливка — с важностью: строка kit задаёт
 * прозрачный фон сама, и без неё исход решал бы порядок стилей.
 */
export const PHRASE_ROW_CLASS: Record<SpeakerSide, string> = {
  incoming: 'bg-(--color-chat-cloud-incoming)! text-(--color-chat-cloud-incoming-foreground)',
  outgoing: 'bg-(--color-chat-cloud-outgoing)! text-(--color-chat-cloud-outgoing-foreground)',
};

/** Время в строке реплики — цветом времени облака её стороны */
export const PHRASE_TIME_CLASS: Record<SpeakerSide, string> = {
  incoming: 'text-(--color-chat-time-incoming)',
  outgoing: 'text-(--color-chat-time-outgoing)',
};

/**
 * Рамка открытой формы записи: у реплики — цветом облака стороны выбранного говорящего, у перебивания
 * и паузы (`event`) — цветом отметки события.
 */
export const RECORD_FORM_FRAME_CLASS: Record<SpeakerSide | 'event', string> = {
  incoming: 'ring-2 ring-(--color-chat-cloud-incoming)',
  outgoing: 'ring-2 ring-(--color-chat-cloud-outgoing)',
  event: 'ring-2 ring-(--color-chat-event)',
};
